import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid } from '@material-ui/core'
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en';
import Calendar from 'react-calendar';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'



export default class AngajatiCvuri extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadCV = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/CvAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getAngajati()
                
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    openCv = (s) => {

        let adresaFisa = new Ws().adresaMedia + `/Angajati/Cv/${s.cv}`

        window.open(adresaFisa)

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='md'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'> Cv-uri Angajati</h2>

                    <Grid container style={{maxHeight:'50 vh', overflow:'auto'}}  >

                        {this.props.listaAngajati.map((s, idx) => {
                            return (
                                <Grid key={idx} style={{ marginBottom: 20, textAlign:'center' }} className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <div
                                        // onClick={()=>{this.selectFile(`file${s.id}`)}}
                                        // onClick={() => { this.props.openDetaliiAngajat(s) }}
                                        className='pm-angajati-picture'
                                        style={{ backgroundImage: `url('${s.poza ? (new Ws().adresaMedia + '/Angajati/' + s.poza) : avatar}')` }}>

                                    </div>
                                    <input type='file' id={`angajatiCv`}
                                            style={{ display: 'none' }}
                                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                            onChange={() => { this.uploadCV('angajatiCv', s.id) }} />
                              

                                    <input id={`angInp${s.id}`}
                                        style={{ width: 'fit-content' }}
                                        className='pm-task-description-input'
                                        type='text'
                                        disabled={true}
                                        value={s.nume} />

                                    {s.cv !== null ?
                                    <div style={{display:'inline-block', verticalAlign:'middle'}}>
                                        <div  onClick={()=>{this.openCv(s)}}   style={{padding:5, backgroundColor:'#22c3b4', borderRadius:10, cursor:'pointer'}}>
                                        <span style={{color:'white'}}>Vezi Cv 
                                            <i className='material-icons' 
                                                 style={{color:'white',
                                                        fontSize:20,
                                                         verticalAlign:'sub'}}>insert_drive_file</i></span>

                                        </div>
                                        <div onClick={()=>{this.selectFile('angajatiCv')}} style={{padding:5, backgroundColor:'rgb(211, 29, 214)', borderRadius:10,cursor:'pointer', marginTop:2}}>            
                                            <span style={{color:'white'}}>Adauga CV <i className='material-icons' 
                                            style={{color:'white',
                                                    fontSize:20,
                                                    verticalAlign:'sub'}}>publish</i></span>   

                                        </div>
                              

                                    </div>
                                                 
                                  
                                    :
                                    <div onClick={()=>{this.selectFile('angajatiCv')}} style={{padding:5, backgroundColor:'rgb(211, 29, 214)', borderRadius:10, display:'inline-block', cursor:'pointer'}}>            
                                    <span style={{color:'white'}}>Adauga CV <i className='material-icons' 
                                    style={{color:'white',
                                            fontSize:20,
                                            verticalAlign:'sub'}}>publish</i></span>   

                                        </div>
                                }    

                                </Grid>
                            )
                        })}






                    </Grid>

                    <DialogActions className="pm-dialog-bottom-buttons">

                        <Button variant="outlined" onClick={this.props.salveaza} className='pm-save-button'>
                            {this.props.limba.comune.save}
                        </Button>




                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}